import { Card, CardContent } from "../ui/card";

export default function StatCard({ label, value, sub, icon: Icon, color = "text-primary", bg = "bg-primary/10" }) {
  return (
    <Card className="border-none shadow-soft">
      <CardContent className="p-5">
        <div className="flex items-center gap-4">
          <div className={`w-11 h-11 ${bg} rounded-xl flex items-center justify-center shrink-0`}>
            <Icon className={`w-5 h-5 ${color}`} />
          </div>
          <div className="min-w-0">
            <p className="text-2xl font-bold truncate">{value}</p>
            <p className="text-xs text-muted-foreground">{label}</p>
            {sub && <p className="text-xs text-muted-foreground mt-0.5">{sub}</p>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
